import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';
import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class StaffSeniorityIndex extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      used_in_planning_aircraft_models: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.exportCsv = this.exportCsv.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/tripulantes/totais/horas', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelos/usados/planejamento/com/fb/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({used_in_planning_aircraft_models: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* aeronaves usadas em planejamento */
    });
  }

  exportCsv(event) {
    var url = "/exportar/senhoridade";
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.titulo}</h3>
      <Link to="/tripulantes/ativos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <div className="table-responsive">
        <button className="btn btn-success btn-xs button-inline" value={this.state.data} onClick={this.exportCsv}>
          <i className="fa fa-fw fa-table"></i> {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.botaoExportarEmCSV}
        </button>
        <table className="table table-stripped table-bordered">
          <thead>
            <tr>
              <th>
                #
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Matricula}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Tripulante}
              </th>
              <th>
              {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Designacoes}
              </th>
              <th>
              {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Quinzena}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Cargo}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Licenca}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Admissao}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Senioridade}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Icao}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Total}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.UmP}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.DoisP}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Heli}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.UmPH}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Mono}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Multi}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.UmPMu}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.MuH}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.UmPMuH}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.GP}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.GP1P}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.MP}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.MP1P}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.PP}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.PP1P}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.IFR}
              </th>
              <th>
                {this.locale.Tripulantes.ListagemDeTripulantesPorSenioridade.tabela.Not}
              </th>
              {Object.keys(self.state.used_in_planning_aircraft_models).map(function(k) {
                return (
                  <th>{self.state.used_in_planning_aircraft_models[k].model}</th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {Object.keys(self.state.data).map(function(k) {
              return (
                <tr>
                  <td>
                    {self.state.data[k].number}
                  </td>
                  <td>
                    {self.state.data[k].inscription}
                  </td>
                  <td>
                    {self.state.data[k].name}
                  </td>
                  <td>
                    {self.state.data[k].designations}
                  </td>
                  <td>
                    {self.state.data[k].period}
                  </td>
                  <td>
                    {self.state.data[k].role_name}
                  </td>
                  <td>
                    {self.state.data[k].license}
                  </td>
                  <td>
                    {self.state.data[k].hired}
                  </td>
                  <td>
                    {self.state.data[k].date_start_str}
                  </td>
                  <td>
                    {self.state.data[k].icao}
                  </td>
                  <td>
                    {self.state.data[k].Total}
                  </td>
                  <td>
                    {self.state.data[k].OneP}
                  </td>
                  <td>
                    {self.state.data[k].TwoP}
                  </td>
                  <td>
                    {self.state.data[k].Heli}
                  </td>
                  <td>
                    {self.state.data[k].OnePH}
                  </td>
                  <td>
                    {self.state.data[k].Mono}
                  </td>
                  <td>
                    {self.state.data[k].Multi}
                  </td>
                  <td>
                    {self.state.data[k].OnePMu}
                  </td>
                  <td>
                    {self.state.data[k].MuH}
                  </td>
                  <td>
                    {self.state.data[k].OnePMuH}
                  </td>
                  <td>
                    {self.state.data[k].GP}
                  </td>
                  <td>
                    {self.state.data[k].OnePGP}
                  </td>
                  <td>
                    {self.state.data[k].MP}
                  </td>
                  <td>
                    {self.state.data[k].OnePMP}
                  </td>
                  <td>
                    {self.state.data[k].PP}
                  </td>
                  <td>
                    {self.state.data[k].OnePPP}
                  </td>
                  <td>
                    {self.state.data[k].IFR}
                  </td>
                  <td>
                    {self.state.data[k].NOT}
                  </td>
                  {Object.keys(self.state.used_in_planning_aircraft_models).map(function(kam) {
                    var fleet = self.state.used_in_planning_aircraft_models[kam].model;
                    return (
                      <td>{self.state.data[k][fleet] ? self.state.data[k][fleet] : "0:0"}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>     
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default StaffSeniorityIndex;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffSeniorityIndex.js